/**
 * Text input format values used by the format select and content description fields.
 */

export const TEXT_FORMAT_PLAIN_TEXT = 'plain_text'
export const TEXT_FORMAT_BASIC_HTML = 'basic_html'
export const TEXT_FORMAT_RESTRICTED_HTML = 'restricted_html'
export const TEXT_FORMAT_FULL_HTML = 'full_html'
export const TEXT_FORMAT_MARKDOWN = 'markdown'
